import { render } from "./AccountSettingPage.vue?vue&type=template&id=52dca5bc&ts=true"
import script from "./AccountSettingPage.vue?vue&type=script&lang=ts"
export * from "./AccountSettingPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../var/local/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__